import axios from 'axios';
const API = axios.create({
  baseURL:     process.env.REACT_APP_API_URL || 'https://api.visinvoke.com',
  // withCredentials: true causes the browser to send the HttpOnly auth_token
  // cookie with every request. This replaces the old Authorization header
  // approach. The JWT is never visible to JavaScript.
  withCredentials: true,
});
// Request interceptor: nothing to inject - cookie is sent automatically.
API.interceptors.request.use(cfg => cfg);
// Response interceptor: handle auth failures and account restrictions.
API.interceptors.response.use(
  r => r,
  err => {
    const status = err.response?.status;
    const body   = err.response?.data || {};

    if (status === 403) {
      // account_locked — user has LOGIN_BLOCK or admin_action_required
      // Route to lock screen with full state payload
      if (body.error === 'account_locked') {
        if (window.location.pathname !== '/account-locked') {
          sessionStorage.setItem('lock_state', JSON.stringify({
            admin_message:      body.admin_message || body.reason || '',
            admin_message_type: body.admin_message_type || 'ERROR',
            action_required:    body.action_required || true,
            restriction_type:   body.restriction_type || 'login_block',
          }));
          window.location.replace('/account-locked');
        }
        return Promise.reject(err);
      }

      // account_restricted — banned (original system)
      if (body.error === 'account_restricted') {
        if (window.location.pathname !== '/account-suspended') {
          const reason = body.admin_message || body.reason || body.message || '';
          sessionStorage.setItem('suspension_reason', reason);
          window.location.replace('/account-suspended');
        }
        return Promise.reject(err);
      }
    }

    if (status === 401) {
      // Session expired or cookie missing - send to login.
      // Public / token-bearing pages legitimately have no session (a user
      // resetting a password or verifying an email is unauthenticated by
      // definition). Never auto-redirect those, or the token in the URL
      // would be lost. Exact-match allowlist only - no wildcards.
      // Skip redirect if a navigation is already in progress (prevents race conditions).
      const publicPaths = [
        '/login',
        '/reset-password',
        '/verify-email',
        '/account-suspended',
        '/account-locked',
        '/contractor-compliance/portal',
      ];
      const navigating = sessionStorage.getItem('vi_navigating');
      if (!navigating && !publicPaths.includes(window.location.pathname)) {
        const returnTo = window.location.pathname === '/tv'
          ? '?redirect=' + encodeURIComponent(window.location.pathname + window.location.search)
          : '';
        window.location.href = '/login' + returnTo;
      }
    }

    return Promise.reject(err);
  }
);
export default API;
